import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-transaction-totals',
  templateUrl: './transaction-totals.component.html',
  styleUrls: ['./transaction-totals.component.css'],
  standalone: false
})
export class TransactionTotalsComponent {
  /** The shared vm object (provides tax, subtotal, taxtotal, total, invoiceTaxes, item). */
  @Input() vm: any;
  /** Emitted when the user clicks the calculate-payment-amount button. */
  @Output() paymentAmountCalc = new EventEmitter<void>();
}
